module.exports = __webpack_public_path__ + "static/img/22-红英小学(冷泉学部).0df361c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/22-红英小学(冷泉学部).png
// module id = iGJ0
// module chunks = 0